import { Type } from 'class-transformer';
import { IsArray, IsBoolean, IsNumber, IsOptional, ValidateNested } from 'class-validator';
import { TransactionSummaryDto } from '../transactions/transaction-summary.dto';
import { SubscriptionSummaryDto } from './subscription-summary.dto';

export class UserSubscriptionHistoryItemDto extends SubscriptionSummaryDto {
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => TransactionSummaryDto)
  @IsOptional()
  transactions?: TransactionSummaryDto[];
}

export class UserSubscriptionHistoryResponseDto {
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => UserSubscriptionHistoryItemDto)
  items!: UserSubscriptionHistoryItemDto[];

  @IsNumber()
  total!: number;

  @IsBoolean()
  hasMore!: boolean;
}
